/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../../components/MKBox";
import MKTypography from "../../../../components/MKTypography";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={4}
      px={2}
      mt={4}
      sx={({ borders: { borderRadius } }) => ({
        borderRadius: borderRadius.lg,
        overflow: "hidden",
      })}
    >
      <Grid container>
        <Grid item xs={12} md={10}>
          <MKTypography variant="h3" color="white" mb={2}>
            The Mission
          </MKTypography>
          <MKTypography variant="body1" color="white" opacity={0.9} mb={2}>
            We love building and creating things! We are driving to finding what applications or
            software can make life easier and better for all. We take innovation seriously and strive
            for thinking how would make the next best thing. Creating apps is our specialty but we
            also delve into whatever we think needs to be looked at. We are not scared to go into
            the unknown of the tech world so that we can learn and build great things. Everyday we
            look ahead into what will come next. We release it is not easy to grab something, an
            idea or product, from the future and bring it here but that is what we do.
          </MKTypography>
          <MKTypography variant="body1" color="white" opacity={0.9}>
            We are committed to creating applications that stand out and serve real needs. Every release
            is shaped around solid user experience and a sense of fun—when users are happy with what we
            ship, that is the measure of success.
          </MKTypography>
        </Grid>
      </Grid>
    </MKBox>
  );
}

export default Team;
